import "./App.css";
import "./Recruiter.css";
import Experience from "./experience/Experience";
import HomepageMetadata from "./HomepageMetadata";
import Header from "./header/Header";
import Home from "./home/Home";
import About from "./about/About";
// import Services from "./services/Services";
import Portfolio, { OtherProjects } from "./potfolio/Portfolio";
import Contact from "./contact/Contact";
import TONearbyLanding from "./tonearby/TONearbyLanding";
import TONearbyPrivacyPolicy from "./tonearby/TONearbyPrivacyPolicy";
import TONearbySupport from "./tonearby/TONearbySupport";

function App() {
  const currentPath = window.location.pathname.replace(/\/$/, "");
  const isTONearbyLandingPage = currentPath === "/tonearby";
  const isTONearbyPrivacyPage = currentPath === "/tonearby/privacy";
  const isTONearbySupportPage = currentPath === "/tonearby/support";

  if (isTONearbyLandingPage) {
    return (
      <div className="App">
        <TONearbyLanding />
      </div>
    );
  }

  if (isTONearbyPrivacyPage) {
    return (
      <div className="App">
        <TONearbyPrivacyPolicy />
      </div>
    );
  }

  if (isTONearbySupportPage) {
    return (
      <div className="App">
        <TONearbySupport />
      </div>
    );
  }

  return (
    <div className="App recruiter-portfolio">
      <HomepageMetadata />
      <Header />
      <main id="main-content" tabIndex="-1">
        <Home />
        <Portfolio />
        <Experience />
        <About />
        <OtherProjects />
        <Contact />
      </main>
    </div>
  );
}

export default App;
